var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnrolledAvatar = function SvgEnrolledAvatar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#748499"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m4.934 11.813 4.08 4.08a8.28 8.28 0 0 0 6.56-5.493L9.12 3.947z",
    clipRule: "evenodd",
    opacity: 0.15
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4E7EC",
    fillRule: "evenodd",
    d: "M11.445 11.547c-.438-2.294-.97-3.2-2.318-3.467.627-.533 1.065-1.413 1.065-2.187 0-1.2-.501-2.16-2.192-2.16s-2.193.96-2.193 2.16c0 .774.438 1.68 1.065 2.187-1.347.267-1.848 1.173-2.318 3.467-.157.72.626.72.626.72h5.639c.03 0 .783 0 .626-.72",
    clipRule: "evenodd"
  })));
};
export { SvgEnrolledAvatar as ReactComponent };
export default __webpack_public_path__ + "fonts/enrolled-avatar-6d90f800bc32ba1aa057d3f21e50043b.svg";